/**
 * King Living Progress Theme
 *
 * Global progress bar styling system:
 * - Progress bar for displaying task completion
 * - Track and filledTrack parts
 * - Supports sizes: xs, sm, md, lg
 * - Supports colorScheme for different colors
 *
 * Based on Chakra UI Progress component:
 * @see https://v2.chakra-ui.com/docs/components/progress/usage
 *
 * @override Extends Chakra UI Progress theme
 */

const Progress = {
  parts: ['track', 'filledTrack'],
  baseStyle: {
    track: {
      bg: 'brandColors.disabledBG', // #E8E8E8 for unfilled track
      borderRadius: '0',
    },
    filledTrack: {
      bg: 'brandColors.greyscale90', // #1B1A18 at 90% opacity
      borderRadius: '0',
      transition: 'all 0.3s ease',
    },
  },
  sizes: {
    xs: {
      track: {
        h: '2px', // 2px height
      },
    },
    sm: {
      track: {
        h: '2px', // 2px height
      },
    },
    md: {
      track: {
        h: '4px', // 4px height (default)
      },
    },
    lg: {
      track: {
        h: '6px', // 6px height
      },
    },
  },
  defaultProps: {
    size: 'sm',
  },
};

export default Progress;
